export default {
	weldMode: {
		selectFacesPrompt: "Selektieren Sie Flächen, welche verschweißt werden sollen.",
		weldlineLabel: "Schweißlinie",
		selectFacePrompt: "Fläche wählen...",
		selectMoreFacesPrompt: "Weitere Flächen auswählen oder anwenden...",
		helpLink: "Hilfe",
		applyButtonTitle: "Die gewählten Schweißlinien erstellen.",
		applyButton: "Anwenden",
		maxDistanceFallback: "die maximal zugelassene Distanz der Materialien",
		someWeldsFailedMessage:
			"Der Algorithmus findet zwischen gewissen Flächen keine Möglichkeit eine Schweißnaht zu erstellen. " +
			"Achten Sie darauf, dass der Abstand zwischen den Flächen nicht mehr als {distance} beträgt und die Kanten parallel sind.",
		errorListIntro: "Im Folgenden werden die einzelnen Fehlermeldungen aufgelistet:",
		someWeldsFailedTitle: "Einige Schweißnähte konnten nicht definiert werden.",
		weldDefinitionFailedTitle: "Schweißnaht kann nicht definiert werden.",
	},
	weldlines: {
		existingWeldlinesTitle: "Bestehende Schweißlinien",
		cleanAllCheckboxLabel: "Alle Schweißnähte verputzen",
		weldlineLabel: "Schweißnaht",
		fillerLabel: "auffüllen",
		pluggedLabel: "gesteckt",
		withCornersLabel: "mit",
		cornerLabel: "Ecke",
		cornerTooltipChoose: "Bitte wählen Sie, ob die Ecke verschweißt werden soll oder nicht.",
		cornerTooltipTooLarge: "Diese Ecke ist zu gross, um verschweißt zu werden. Bitte beachten Sie unseren",
		cornerTooltipConstructionLink: "Konstruktionshinweis.",
		defineSegmentsTitle: "Muster definieren",
		deleteWeldlineTitle: "Schweißnaht löschen",
		segmentDialogTitle: "Schweißnaht in Segmente unterteilen.",
		segmentDialogInfo1:
			"Die Schweißnaht kann auf der vollen Länge geschweißt werden. Das führt zu hoher Festigkeit " +
			"aber auch zu einem hohen Wärmeeintrag und damit verbunden zu einem möglichen Verzug des Bauteils.",
		segmentDialogInfo2:
			"Wenn Sie die Schweißnaht in Segmente unterteilen und die Segmente kurz halten, " +
			"können Sie diesem Effekt entgegen wirken.",
		numberOfSegmentsLabel: "Anzahl Segmente:",
		segmentLengthLabel: "Länge eines Segments [mm]:",
		singleSegmentInfo:
			"Wenn nur ein Segment definiert ist, wird die Länge des Segments automatisch der Länge der Schweißnaht gleichgestellt.",
		applyButton: "Übernehmen",
		cancelButton: "Abbrechen",
		errorSegmentsMustBeInteger: "Anzahl Segmente muss eine Ganzzahl sein.",
		errorSegmentsMinOne: "Anzahl Segmente muss mind. 1 sein.",
		errorSegmentMinLength: "Ein Segment muss mind. 5mm lang sein.",
		errorSegmentsTotalTooLong:
			"Die Gesamtlänge der Segmente ist länger als die Schweißnaht. " +
			"Beachten Sie auch, dass zwischen den Segmenten mindestens 5mm Abstand verbleiben muss.",
	},
	rollDirectionMode: {
		noDirectionDefined:
			"Es ist noch keine Schliffrichtung definiert. Wählen Sie eine Aussenkante für die Schliffrichtung.",
		adjustHint:
			"Sie können den Verlauf der Schliffrichtung definieren, indem Sie den Winkel verändern oder auf eine andere Aussenkante klicken.",
		angleRangeLabel: "(0° bis 180°)",
	},
	measuringMode: {
		selectPrompt: "Selektieren Sie Flächen oder Kanten, um zu messen.",
	},
};
